import React from 'react';
import { Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStore } from '../store';
import { CircularProgress, Box } from '@mui/material';

interface ProtectedRouteProps {
    children: React.ReactNode;
    adminOnly?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = observer(({ children, adminOnly = false }) => {
    const { authStore } = useStore();

    // Показываем загрузку, пока проверяем токен
    if (authStore.loading) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="100vh"
            >
                <CircularProgress />
            </Box>
        );
    }

    // Если не авторизован, перенаправляем на логин
    if (!authStore.isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // Если требуются права администратора, но пользователь не админ
    if (adminOnly && !authStore.isAdmin) {
        return <Navigate to="/dashboard" replace />;
    }

    return <>{children}</>;
});

export default ProtectedRoute;